module.exports = __webpack_public_path__ + "img/bg-video.fb31fed8.png";